/* eslint-disable react/no-string-refs */
import React from 'react'
import { Layout, Row, Col, Carousel, message } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import Lottie from 'lottie-react-web'
import { GlobalHeader } from '../../components'
import { LoginForm, RegisterForm, ResetPasswordForm } from './components'
import { getAuth } from '../../utils/global'
import { connect } from 'react-redux'
import './index.less'
import { bindActionCreators } from 'redux'
import { setCurrentLogin } from '../../redux/reducers/baseInfo'
import animateJsonBanner from '../../assets/lottie/banner/data.json'
import animateJsonProduct from '../../assets/lottie/product/data.json'

interface ModuleType {
	title: string
	intro: string
	icon: string
	path?: string
	disabled?: boolean
	cooming?: boolean
	className: string
	hover: string
}

const { Content, Footer } = Layout

const moduleList: ModuleType[] = [
	{
		title: '内容检索',
		intro: '来自多个商品库、公众号及专业生产的视频、图片等素材内容',
		icon: require('../../assets/img/content-check.png'),
		hover: require('../../assets/img/content-check.gif'),
		path: '/main/content/businessData/index',
		className: 'content-check',
	},
	{
		title: '上传内容',
		intro: '内容数据入库，定义内容属性详情，业务、场景归类',
		icon: require('../../assets/img/upload_content@2x.png'),
		hover: require('../../assets/img/create-content.gif'),
		path: '/main/content/library/addContent',
		className: 'create-content',
	},
	{
		title: '增长物料审核',
		intro: '广告物料审核流程线上化，包含业务、法务环节对于代理素材的审批流',
		icon: require('../../assets/img/content_review.png'),
		hover: require('../../assets/img/content-review.gif'),
		className: 'content-review',
		path: '/main/review/waitReview',
	},
	{
		title: '酒旅物料审核',
		intro: '酒旅住宿页面、活动、物料、新媒体审核，包含系统敏感词检测',
		icon: require('../../assets/img/create_audio@2x.png'),
		hover: require('../../assets/img/create-audio.gif'),
		path: '/main/review/newMediaMcn',
		className: 'create-audio',
	},
	{
		title: '活动审核',
		intro: '活动审核，包含系统敏感词检测',
		icon: require('../../assets/img/create_audio@2x.png'),
		hover: require('../../assets/img/create-audio.gif'),
		path: '/main/review/newMarket',
		className: 'newMarket',
	},
	{
		title: '制作视频',
		intro: '使用内容库中素材加工视频，添加首帧、尾帧、特效、音乐',
		icon: require('../../assets/img/create_video@2x.png'),
		hover: require('../../assets/img/create-video.gif'),
		path: '/main/create/video',
		className: 'create-video',
	},
	{
		title: '图文合成',
		intro: '生成契合图文内容投放渠道的图文作品，支持编辑、修改',
		icon: require('../../assets/img/create_article@2x.png'),
		hover: require('../../assets/img/create-article.gif'),
		path: '/main/create/article',
		className: 'create-article',
	},
	{
		title: '新媒体物料审核',
		intro: '新媒体图文审核线上流程，含系统敏感词检测、法务审核环节',
		icon: require('../../assets/img/content_review.png'),
		hover: require('../../assets/img/content-review.gif'),
		path: '/main/review/newMediaVideo',
		className: 'newMediaVideo',
	},
	{
		title: '品牌广告投放审核',
		intro: '品牌广告投放审核，包含系统敏感词检测',
		icon: require('../../assets/img/content_review.png'),
		hover: require('../../assets/img/content-review.gif'),
		path: '/main/review/tradeMark',
		className: 'tradeMark',
	},
	// {
	// 	title: '制作图片',
	// 	intro: '智能制作图片，以渠道投放结果为导向，执行图片加工厂职能',
	// 	icon: require('../../assets/img/create_picture@2x.png'),
	// 	hover: require('../../assets/img/create-picture.gif'),
	// 	path: '/main/create/picture',
	// 	className: 'create-picture disabled cooming',
	// 	cooming: true,
	// 	disabled: true,
	// },
]

const placeList = [
	{
		title: '微信',
		icon: require('../../assets/icon/svg/logo/wx.svg'),
		class: 'wx',
	},
	{
		title: '抖音',
		icon: require('../../assets/icon/svg/logo/dy.svg'),
		class: 'dy',
	},
	{
		title: '快手',
		icon: require('../../assets/icon/svg/logo/ks.svg'),
		class: 'ks',
	},
	{
		title: '知乎',
		icon: require('../../assets/icon/svg/logo/zh.svg'),
		class: 'zh',
	},
	{
		title: '网易云',
		icon: require('../../assets/icon/svg/logo/wyy.svg'),
		class: 'wyy',
	},
	{
		title: '新浪',
		icon: require('../../assets/icon/svg/logo/wb.svg'),
		class: 'wb',
	},
	{
		title: '腾讯新闻',
		icon: require('../../assets/icon/svg/logo/txxw.svg'),
		class: 'txxw',
	},
	{
		title: '百家号',
		icon: require('../../assets/icon/svg/logo/bjh.svg'),
		class: 'bjh',
	},
	{
		title: 'qq看点',
		icon: require('../../assets/icon/svg/logo/qqkd.svg'),
		class: 'qqkd',
	},
	{
		title: '神马搜索',
		icon: require('../../assets/icon/svg/logo/smss.svg'),
		class: 'smss',
	},
	{
		title: '百度',
		icon: require('../../assets/icon/svg/logo/bd.svg'),
		class: 'baidu',
	},
	{
		title: '360',
		icon: require('../../assets/icon/svg/logo/360.svg'),
		class: 'c360',
	},
	{
		title: '小红书',
		icon: require('../../assets/icon/svg/logo/xhs.svg'),
		class: 'xhs',
	},
	{
		title: '头条',
		icon: require('../../assets/icon/svg/logo/tt.svg'),
		class: 'tt',
	},
	{
		title: '搜狐',
		icon: require('../../assets/icon/svg/logo/sh.svg'),
		class: 'sh',
	},
	{
		title: '喜马拉雅',
		icon: require('../../assets/icon/svg/logo/xmly.svg'),
		class: 'xmly',
	},
	{
		title: '网易新闻',
		icon: require('../../assets/icon/svg/logo/wyxw.svg'),
		class: 'wyxw',
	},
	{
		title: '更多',
		icon: require('../../assets/icon/svg/logo/wyxw.svg'),
	},
]
const friendLinks = [
	{
		title: '平台地图',
		type: 'route',
		links: [
			{
				title: '作品管理',
				url: '/main/content/worksManage/index',
			},
			{
				title: '视频制作',
				url: '/main/create/video',
			},
			{
				title: '长图文制作',
				url: '/main/create/article',
			},
			{
				title: '音频转文字',
				url: '/main/create/audio',
			},
			{
				title: '文字转音频',
				url: '/main/content/library/addContent',
			},
			{
				title: '标签管理',
				url: '/main/tag',
			},
			{
				title: '视频高级编辑Studio',
				url: '',
			},
		],
	},
	{
		title: '友情链接',
		type: 'link',
		links: [
			{
				title: '移动研发平台',
				url: 'http://mas.vip.elong.com/',
			},
			{
				title: '统一网关',
				url: 'http://tefe.17usoft.com/',
			},
			{
				title: '神盾局',
				url: 'http://sdweb.vip.elong.com/website/index',
			},
			{
				title: '福特',
				url: 'http://furt-admin.corp.elong.com/#/services',
			},
			{
				title: 'JEAN',
				url: 'http://jean.corp.elong.com/',
			},
			{
				title: '同程旅行',
				url: 'https://www.ly.com/',
			},
			{
				title: '艺龙网',
				url: 'http://www.elong.com/',
			},
			{
				title: '同程金服',
				url: 'https://jr.ly.com/',
			},
		],
	},
	{
		title: '关于我们',
		type: 'email',
		links: [
			{
				title: '联系我们',
				url: 'dong3.yan@ly.com',
			},
			{
				title: '加入我们',
				url: 'dong3.yan@ly.com',
			},
			{
				title: '意见反馈：dong3.yan@ly.com',
				url: '',
			},
		],
	},
	{
		title: '关注我们',
		type: 'qcode',
		links: [
			{
				url: require('../../assets/img/qcode.png'),
			},
		],
	},
]
const sliderList = [
	{
		title: '视频高级编辑',
		icon: require('../../assets/img/video-slider.png'),
		route: '',
	},
	{
		title: '文字AI生成音频',
		icon: require('../../assets/img/ai-slider.png'),
		route: '/main/content/library/addContent',
	},
	{
		title: '长图文制作',
		icon: require('../../assets/img/article-slider.png'),
		route: '/main/create/article',
	},
]

class Index extends React.Component {
	state = {
		animationStyle: {
			first: {},
			second: {},
			third: {},
		},
		allRoutes: [],
	}

	onModuleClick(module: ModuleType) {
		let allRoutes = this.state.allRoutes

		if (allRoutes.length === 0) {
			this.getRouteAuth().then(res => {
				allRoutes = res
				this.setState({
					allRoutes: res,
				})
				this.goToMoudle(allRoutes, module)
			})
		} else {
			this.goToMoudle(allRoutes, module)
		}
	}
	goToMoudle(allRoutes, module) {
		if (!this.props.userInfo.workid) {
			message.warning('请先登录')
			return
		}
		if (allRoutes.includes(module.path) && this.props.userInfo.ispublicnetwork === 0) {
			if (module.title === '上传内容') {
				this.props.history.push(module.path)
			} else {
				this.props.history.push(module.path)
			}
		} else {
			// 外网代理 点击 增长物料审核进入内容库 (外网访问用户ispublicnetwork也是1，代理有内容库权限)！！！=>业务需求
			if (
				module.title === '增长物料审核' &&
				this.props.userInfo.ispublicnetwork === 1 &&
				allRoutes.includes('/main/content/library')
			) {
				this.props.history.push('/main/content/library/index')
			} else {
				message.warning('对不起您没有权限，请点击右上角申请权限')
			}
		}
	}
	beforeChange(cur, next) {
		// console.log('cur==',cur, 'next==',next)
		const animationStyle = {
			first: {
				left: `-${next * 445}px`,
				transition: 'left 0.9s linear 0s',
			},
			second: {
				left: `-${next * 445}px`,
				transition: 'left 0.6s linear 0.3s',
			},
			third: {
				left: `-${next * 445}px`,
				transition: 'left 0.3s linear 0.6s',
			},
		}
		this.setState({
			animationStyle,
		})
	}
	switchCarousel(type) {
		if (type === 'prev') {
			this.refs.carousel.prev()
		} else {
			this.refs.carousel.next()
		}
	}
	getRouteAuth() {
		return new Promise(resolve => {
			getAuth('route')
				.then(res => {
					const allRoutes = []
					res.forEach(item => {
						allRoutes.push(item.resourceVal)
					})
					resolve(allRoutes)
				})
				.catch(() => {
					resolve([])
				})
		})
	}

	render() {
		const { animationStyle, allRoutes } = this.state
		const current = this.props.currentLogin
		const staffLogin = () => {
			console.log(
				'http://tccommon.t.17usoft.com/oauth/authorize?response_type=code&scope=read&redirect_uri=https%3A%2F%2Fda.elong.com%2F%23%2Findex&client_id=uk7bj.java.content.dispense.centre&state=9d37e7a4059f6db597a483d2c48e0f4c'
			)
			window.location.href = `${process.env.REACT_APP_LOGIN}/oauth/authorize?response_type=code&scope=read&redirect_uri=${process.env.REACT_APP_REDIRECT}&client_id=${process.env.REACT_APP_ID}&state=${process.env.REACT_APP_SECRET}`
		}
		const setCurrent = val => {
			this.props.actions.setCurrentLogin(val)
		}
		const switchComponent = () => {
			const map = {
				login: (
					<LoginForm
						goRegister={() => setCurrent('register')}
						goResetPassword={() => setCurrent('resetPassword')}
						goStaffLogin={staffLogin}
					/>
				),
				register: <RegisterForm goLogin={() => setCurrent('login')} />,
				resetPassword: <ResetPasswordForm goLogin={() => setCurrent('login')} />,
			}
			return map[current] || null
		}
		return (
			<Layout className="home-page">
				<GlobalHeader showMenu={true} />
				{current ? (
					<div className="login-wrap">
						<div className="card">
							<div className="close" onClick={() => setCurrent('')}>
								×
							</div>
							{switchComponent()}
						</div>
					</div>
				) : (
					''
				)}
				<Content className="home-content">
					<div className="banner">
						<Lottie
							// direction={this.state.isToggled ? 1 : -1}
							options={{
								animationData: animateJsonBanner,
								assetsPath: 'http://m.elongstatic.com/cdc/com-static/banner/',
								loop: true,
								autoplay: true,
							}}
						/>
						<div className="banner-content">
							<h1>达芬奇平台</h1>
							<p className="extra">Integrated Operating Center</p>
							<p className="intro">
								集成同程旅行多业务线优质、海量、实时内容资源，多维度、全视角、精准化管理全平台内容数据。产业链化维护内容矩阵，上中下游精细锚点传播。实现获客成本逐优化，资源效率指数化，增长循环结构化。
							</p>
						</div>
					</div>
					<div className="modules-wrap">
						<Row gutter={[30, 20]}>
							{moduleList.map((module, i) => {
								const { title, intro, icon, className, cooming, disabled, hover } = module
								return (
									<Col span={8} key={i}>
										<div
											style={{
												cursor: `${
													this.state.allRoutes.includes(module.path) ||
													(module.title === '增长物料审核' &&
														this.props.userInfo.ispublicnetwork === 1 &&
														this.state.allRoutes.includes('/main/content/library'))
														? 'pointer'
														: 'default'
												}`,
											}}
											className={`module ${className}`}
											onClick={() => !disabled && !cooming && this.onModuleClick(module)}
										>
											<img className="icon" src={icon} alt="" />
											<img className="icon hover" src={hover} alt="" />
											<div>
												<p className="title">{title}</p>
												<p className="intro">{intro}</p>
											</div>
										</div>
									</Col>
								)
							})}
						</Row>
					</div>
					<div className="product-wrap">
						<div className="product">
							<div className="com-hd">
								<div className="title"></div>
								<p className="info">全环节效果引擎，为同程旅行打造富媒体内容生态</p>
							</div>
							<div className="bd">
								<div className="product-lottie">
									<div className="creat-content popover">
										<div className="inner">
											<div className="hd">内容制作</div>
											<div className="bd">
												使用图片、视频素材制作短视频（添加字幕、智能添加尾帧）、AI智能音频生成、长图文作品合成
											</div>
										</div>
									</div>
									<div className="manage-content popover">
										<div className="inner">
											<div className="hd">内容管理</div>
											<div className="bd">
												分为内容库和作品库两个板块，列表页主要功能点类似。内容库作为素材集合站，提供作品制作的内容素材。来自业务线、抓取、上传等方式收集视频、音频、图片、文字等内容形式
											</div>
										</div>
									</div>
									<div className="part-throw popover">
										<div className="inner">
											<div className="hd">分发投放</div>
											<div className="bd">
												站外多渠道矩阵分发业已收集制作好的内容，覆盖短视频、社交媒体（公众号）等多渠道
											</div>
										</div>
									</div>
									<div className="effect-monitor popover">
										<div className="inner">
											<div className="hd">效果监测</div>
											<div className="bd">
												纵向、横向内容渠道效果反馈，数据分析，重新调整制定分发策略标准
											</div>
										</div>
									</div>
									<div className="collect-material popover">
										<div className="inner">
											<div className="hd">收集素材</div>
											<div className="bd">
												聚合全集团多种数据来源，涵盖数条业务线及知识产权数据，收集视频、音频、图片、文字等不同内容形式的素材
											</div>
										</div>
									</div>
									<div className="material-library popover">
										<div className="inner">
											<div className="hd">素材库</div>
											<div className="bd">
												素材进入素材库，自动与手动打标等方式将素材存放在内容货架上
											</div>
										</div>
									</div>
									<Lottie
										options={{
											animationData: animateJsonProduct,
											assetsPath: 'http://m.elongstatic.com/cdc/com-static/product/',
											loop: true,
											autoplay: true,
										}}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="produce-wrap">
						<div className="product">
							<div className="com-hd">
								<div className="title"></div>
								<p className="info">机器灵感创作工厂，生成作品智能化、便捷化、绿色化</p>
							</div>
							<div className="bd">
								<div className="main-content">
									<div className="left-area">
										<div className="carousel-wrap">
											<div className="prev" onClick={this.switchCarousel.bind(this, 'prev')}></div>
											<div className="next" onClick={this.switchCarousel.bind(this, 'next')}></div>
											<Carousel
												ref="carousel"
												autoplay
												dots={false}
												autoplaySpeed={2500}
												slidesToShow={1}
												slidesToScroll={1}
												beforeChange={this.beforeChange.bind(this)}
											>
												{sliderList.map(item => {
													return (
														<div className="carousel-item" key={item.title}>
															{item.route && (
																<Link
																	className="route"
																	to={allRoutes.includes(item.route) ? item.route : ''}
																>
																	开始你的创作
																	<RightOutlined />
																</Link>
															)}
															<img src={item.icon} alt={item.title} />
														</div>
													)
												})}
											</Carousel>
										</div>
									</div>
									<div className="right-area">
										<div className="message-list">
											<div className="message-item-wrap" style={animationStyle.first}>
												<div className="message-item">
													<div className="hd">字幕按时间自定义编辑</div>
													<div className="bd">自定义字幕的显示方式</div>
													<div className="hd">DIY视频一站式剪辑制作</div>
													<div className="bd">在图片、视频合成新短片基础上，丰富您的制作元素</div>
												</div>
												<div className="message-item">
													<div className="hd">添加素材更方便</div>
													<div className="bd">
														直接从内容库素材中搜索添加生成长图文所需要的图片、视频等元素，丰富您的图文制作内容
													</div>
												</div>
												<div className="message-item">
													<div className="hd">一键生成智能语音</div>
													<div className="bd">
														音频制作功能中添加文字后，选择音源即可智能转换成您想要的音频
													</div>
												</div>
											</div>
											<div className="message-item-wrap" style={animationStyle.second}>
												<div className="message-item">
													<div className="hd">使用自创贴纸创作</div>
													<div className="bd">
														平台御用设计师原创系列贴纸，满足OTA相关的元素加持，为视频制作带来灵感元素，令您制作的视频与众不同
													</div>
												</div>
												<div className="message-item">
													<div className="hd">适应多种渠道效果</div>
													<div className="bd">
														与公众号、小红书、知乎等站外格式适应，一键制作，多向可用
													</div>
												</div>
												<div className="message-item">
													<div className="hd">使用生成的音频制作视频</div>
													<div className="bd">在视频制作中国添加素材库中制作好的音频作为背景音</div>
												</div>
											</div>
											<div className="message-item-wrap" style={animationStyle.third}>
												<div className="message-item">
													<div className="hd">正版素材，放心使用</div>
													<div className="bd">海量素材库免费使用，区块链技术保护您的内容版权</div>
												</div>
												<div className="message-item">
													<div className="hd">图文编辑重构</div>
													<div className="bd">
														将图文内容规划、重组、编辑、调整，持续输出优质内容
													</div>
												</div>
												<div className="message-item">
													<div className="hd">多种音源（即将开发）</div>
													<div className="bd">多种音源效果，作品更显生动</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="place-wrap">
						<div className="place">
							<div className="com-hd">
								<div className="title"></div>
								<p className="info">逐步覆盖多个主流内容渠道，实现平台配置定时/一键分发</p>
								<div className="more-info">
									<div className="item">
										<div className="num">5大</div>
										<div className="text">定向维度</div>
									</div>
									<div className="item">
										<div className="num">2000+</div>
										<div className="text">人群种类</div>
									</div>
								</div>
							</div>
							<div className="bd">
								{placeList.map(item => {
									return item.title !== '更多' ? (
										<div className="box" key={item.title}>
											<div className={`item ${item.class}`}>
												<img src={item.icon} alt={item.title} />
											</div>
										</div>
									) : (
										<div className="more box" key={item.title}>
											更多合作开发中...
										</div>
									)
								})}
							</div>
						</div>
					</div>
					<div className="promotion-wrap">
						<div className="promotion">
							<div className="com-hd">
								<div className="title"></div>
								<p className="info">从创意制作到效果监控，达芬奇平台促进同程旅行营销</p>
							</div>
							<div className="bd">
								<p>通过数据分析反哺内容运营，提升推荐效率、分发效率以及资源曝光</p>
							</div>
						</div>
					</div>
				</Content>
				<Footer className="home-footer">
					<div className="friend-links">
						<div className="friend-links-list">
							{friendLinks.map((item, i) => {
								return (
									<div className="friend-links-item" key={i}>
										<div className="hd">{item.title}</div>
										<div className="bd">
											{item.type === 'route' &&
												item.links.map((link, j) => {
													return (
														<div key={j}>
															{link.url ? (
																<Link to={allRoutes.includes(link.url) ? link.url : ''}>
																	{link.title}
																</Link>
															) : (
																<span>{link.title}</span>
															)}
														</div>
													)
												})}
											{item.type === 'link' &&
												item.links.map((link, j) => {
													return (
														<div key={j}>
															<a href={link.url} rel="noopener noreferrer" target="_blank">
																{link.title}
															</a>
														</div>
													)
												})}
											{item.type === 'email' &&
												item.links.map((link, j) => {
													return (
														<div key={j}>
															{link.url ? (
																<a
																	href={`mailto:${link.url}`}
																	rel="noopener noreferrer"
																	target="_blank"
																>
																	{link.title}
																</a>
															) : (
																<span>{link.title}</span>
															)}
														</div>
													)
												})}
											{item.type === 'qcode' &&
												item.links.map((link, j) => {
													return (
														<div key={j}>
															<img src={link.url} alt="二维码" />
														</div>
													)
												})}
										</div>
									</div>
								)
							})}
						</div>
					</div>
					<p className="address">地址：北京市朝阳区酒仙桥北路甲10号院301楼102栋同程旅行大厦</p>
					<p className="info">
						Copyright © 2002-2020 版权所有 同程网络科技股份有限公司| 苏ICP备09033604号-21
					</p>
				</Footer>
			</Layout>
		)
	}
}
function mapStateToProps(state) {
	return {
		userInfo: state.baseInfo.userInfo,
		currentLogin: state.baseInfo.currentLogin,
	}
}
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ setCurrentLogin }, dispatch),
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(Index)
